import React from "react";
import { DIVISIONS } from "../../../src/constants.js"
import DivisionalReportsPage from "./DivisionalReportsPage.js";

export default function DriveNationReports() {
  return <DivisionalReportsPage division={DIVISIONS.DRIVE_NATION}/>
};